import {
  useCallback,
  useLayoutEffect,
  useState,
  type MutableRefObject,
  type ReactNode,
} from "react";
import { createPortal } from "react-dom";

interface ReportPrintFrameProps {
  children: ReactNode;
  frameRef: MutableRefObject<HTMLIFrameElement | null>;
  title: string;
}

export function ReportPrintFrame({
  children,
  frameRef,
  title,
}: ReportPrintFrameProps) {
  const [frameBody, setFrameBody] = useState<HTMLElement | null>(null);

  const attachFrame = useCallback(
    (frame: HTMLIFrameElement | null) => {
      frameRef.current = frame;
      setFrameBody(frame?.contentDocument?.body ?? null);
    },
    [frameRef],
  );

  useLayoutEffect(() => {
    const frame = frameRef.current;
    const document = frame?.contentDocument;
    if (!document) return;

    document.documentElement.lang = "pt-BR";
    document.documentElement.style.overflow = "hidden";
    document.body.style.margin = "0";
    document.body.style.background = "#eef2f7";
    document.body.style.overflow = "hidden";
    setFrameBody(document.body);
  }, [frameRef]);

  return (
    <>
      <iframe
        className="report-print-frame"
        ref={attachFrame}
        title={title}
        tabIndex={-1}
      />
      {frameBody &&
        createPortal(
          <div className="report-frame-root">{children}</div>,
          frameBody,
        )}
    </>
  );
}
